// JavaScript Document
import Vue from 'vue'
import Vuex from 'vuex'
import rwJS from '@/assets/js/rwJS.js'
import { Message } from 'element-ui';

var rwJSObj = new rwJS();

Vue.use(Vuex)
//创建strore 对象
const store = new Vuex.Store({
  state: {
    //电脑端
    menuData: [],//主菜单
    headImgMenuData: [],//右上角头像菜单
    platFormMenuData: [],//平台管理菜单
    developerMenuData: [],//开发者管理菜单
    joinSiteMenuData: [],//加入企业菜单

    //手机端
    workMenuData: [],//工作台菜单
    menuDataByStoreID: [],//根据StoreID获取菜单

    langPackData: {},//语言包
    SiteID: null,//企业id
  },
  mutations: {
    //改变语言包数据的方法
    changeLangPackData(state, data) {
      state.langPackData = data;
    },
    //改变电脑端菜单数据方法
    changeMenuData(state, data) {
      state.menuData = data;
    },
    //改变右上角头像菜单数据方法
    changeHeadImgMenuData(state, data) {
      state.headImgMenuData = data;
    },
    //改变平台管理菜单数据方法
    changePlatFormMenuData(state, data) {
      state.platFormMenuData = data;
    },
    //改变开发者菜单数据方法
    changeDeveloperMenuData(state, data) {
      state.developerMenuData = data;
    },
    //改变加入企业菜单数据方法
    changeJoinSiteMenuData(state, data) {
      state.joinSiteMenuData = data;
    },
    //改变手机端菜单数据方法
    changeWorkMenuData(state, data) {
      state.workMenuData = data;
    },
    //改变工作台-平台管理菜单数据方法
    changeMenuDataByStoreID(state, data) {
      state.menuDataByStoreID = data;
    },
    //获取企业id
    getSiteID(state, data) {
      state.SiteID = data
    }
  },
  actions: {
    //获取后台语言包
    getLangPackByBackstage(state, data) {

      return new Promise((resolve, reject) => {
        if (Object.keys(state.state.langPackData).length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.langPackData);
          return;
        }
        console.log("本地存储数据");
        console.log(localStorage.getItem('langPackData'));

        rwJSObj.rwRequest({
          url: '?p=index&a=getLangPackByBackstage',
          data: {}
        }).then((res) => {
          console.log("接口返回数据");
          console.log(res.data);
          localStorage.setItem('langPackData', res.data);
          state.commit('changeLangPackData', res.data);
          resolve(res.data);
        })
      })
    },

    /*****************************电脑端******************************/
    //获取菜单数据的方法
    getMenuData(state, data) {
      return new Promise((resolve, reject) => {
        if (state.state.menuData.length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.menuData);
          return;
        }
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: 1 }
        }).then((res) => {
          state.commit('changeMenuData', res.data);
          resolve(res.data);
        })
      })
    },
    //获取右上角头像菜单的方法
    getHeadImgMenuData(state, data) {
      return new Promise((resolve, reject) => {
        if (state.state.headImgMenuData.length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.headImgMenuData);
          return;
        }
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: 2 }
        }).then((res) => {
          state.commit('changeHeadImgMenuData', res.data);
          resolve(res.data);
        })
      })
    },
    //获取平台管理菜单
    getPlatFormMenuData(state, data) {
      return new Promise((resolve, reject) => {
        if (state.state.platFormMenuData.length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.platFormMenuData);
          return;
        }
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: 44 }
        }).then((res) => {
          state.commit('changePlatFormMenuData', res.data);
          resolve(res.data);
        })
      })
    },
    //获取开发者管理菜单
    getDeveloperMenuData(state, data) {
      return new Promise((resolve, reject) => {
        if (state.state.developerMenuData.length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.developerMenuData);
          return;
        }
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: 43 }
        }).then((res) => {
          state.commit('changeDeveloperMenuData', res.data);
          resolve(res.data);
        })
      })
    },
    //获取加入企业菜单
    getJoinSiteMenuData(state, data) {
      return new Promise((resolve, reject) => {
        if (state.state.joinSiteMenuData.length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.joinSiteMenuData);
          return;
        }
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: 66 }
        }).then((res) => {
          state.commit('changeJoinSiteMenuData', res.data);
          resolve(res.data);
        })
      })
    },
    //获取用户信息
    getUserInfo(state, data) {
      return new Promise((resolve, reject) => {
        rwJSObj.rwRequest({
          url: '?p=personnelUser&a=Info',
          data: {}
        }).then((res) => {
          state.commit('getSiteID', res.data.Info.SiteID);
          resolve(res.data.Info.SiteID);
        })
      })
    },
    /*****************************手机端******************************/
    //获取工作台菜单
    getWorkMenuData(state, data) {
      return new Promise((resolve, reject) => {
        if (state.state.workMenuData.length > 0 && typeof (data) == 'object' && data.noReload) {
          resolve(state.state.workMenuData);
          return;
        }
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: 123 }
        }).then((res) => {
          state.commit('changeWorkMenuData', res.data);
          resolve(res.data);
        })
      })
    },
    //根据StoreID获取菜单数据
    getMenuListByStoreID(state, data) {
      return new Promise((resolve, reject) => {
        rwJSObj.rwRequest({
          url: '?p=index&a=getMenuList',
          data: { StorePID: data.StoreID, layerNum: data.layerNum }
        }).then((res) => {
          state.commit('changeMenuDataByStoreID', res.data);
          resolve(res.data);
        })
      })
    },
  }
})
//导出 store 对象
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js